/**
 * @author Yaochao
 * @date 2021/8/9 16:29
 * @description
 */
import React from 'react'
import CorpApi from "../../public/corp_api";
import IconEnterpriseWeChat from "../../../iconfont/enterpriseWeChat/enterpriseWeChat"
import IconPurpleKun from "../../../iconfont/purpleKun/purpleKun"
import IconAuthorization from "../../../iconfont/authorization/authorization"
import IconAuthorizationBackups from "../../../iconfont/authorization/authorizationBackups"
import {Button, Steps, Tabs} from "antd"
import {Path} from "../../public/path";
import PopupMask from "../../cmpts/PopupMask";
import NextStep from "../../cmpts/NextStep";
import AuthorizationEstablish from "../authorizationProgress/authorizationEstablish/authorizationEstablish";
import AuthorizationSubmit from "../authorizationProgress/authorizationSubmit/authorizationSubmit"
import AuthorizationConfiguration from "../authorizationProgress/authorizationConfiguration/authorizationConfiguration";
import AuthorizationModification from "../authorizationProgress/authorizationModification/authorizationModification";
import AuthorizationCallback from "../authorizationProgress/authorizationCallback/authorizationCallback";
import Store from "../../store";
import Util from "../../public/utils";
import {Link} from "react-router-dom";
import IconSuccess from "../../../iconfont/success";
import ZkModal from "../../common/modal/zkModal";
import IconWX from "../../../iconfont/wX";
import serviceOrCode from "../../../images/config/authorizationProgress/serviceOrCode.png"
import IconZkLogo from "../../../iconfont/logo/zkLogo";
import Message from "../../common/message";
import customerServiceQRCode from "../../../images/newCustomerServiceQRCode.png"
import authorizationSuccess from "../../../images/authorizationSuccess.png"
import newAuthorization from "../../../images/newAuthorization.png"
const {Step} = Steps
const {TabPane} = Tabs

class StepByStep extends React.Component {
    constructor(props) {
        super(props);
        this.toAuthorize = this.toAuthorize.bind(this);//去授权
        this.toRegister = this.toRegister.bind(this);//去注册
        this.contactCustomerService = this.contactCustomerService.bind(this)
        this.state = {
            qrCode:'',//推广的二维码
            saveLoading: false,//保存按钮加载
            activeKey: null,//授权状态
            // aeskey:'',
            // url:'',
            // token:'',
            postData: {}
        }
    }
    componentDidMount() {
        // this.requestStatus();
    }
    // requestStatus = () => {
    //     CorpApi.getEnterpriseWechatAuthoriztionStuatus((data) => {
    //         console.log(this.state.qrCode,'77777777777777')
    //         console.log(data.progress != 1,'888888888888888')
    //         if (this.state.qrCode && data.progress != 1) {
    //             this.setState({
    //                 activeKey: data.progress
    //             },()=>{
    //                 console.log(this.state.activeKey,'999999999999999999')
    //             })
    //             return;
    //         }
    //         this.setState({
    //             activeKey: data.progress
    //         })
    //         //如果状态等于1   请求待开发的二维码
    //         if (+data.progress === 1) {
    //             //请求待开发二维码授权接口
    //             CorpApi.getCorpAuthTempkateAuthCode((data)=>{
    //                 this.setState({//请求到二维码以后 开始轮询状态接口
    //                     qrCode:data.qrCode
    //                 },()=>{
    //                     setInterval(()=>{
    //                         this.requestStatus();
    //                     },2000)
    //                 })
    //             },()=>{})
    //         }
    //     }, () => {})
    // }
    componentDidMount() {
        //请求授权状态
        CorpApi.getEnterpriseWechatAuthoriztionStuatus((data) => {
            this.setState({
                activeKey: data.progress
            },()=>{
                if(this.state.activeKey == 1){ //如果状态等于1   请求待开发的二维码
                    //请求待开发二维码授权接口
                    CorpApi.getCorpAuthTempkateAuthCode((data)=>{
                        this.setState({//请求到二维码以后 开始轮询状态接口
                            qrCode:data.qrCode
                        },()=>{
                            setInterval(()=>{
                                CorpApi.getEnterpriseWechatAuthoriztionStuatus((data)=>{
                                    if(data.progress != 1){
                                        this.setState({
                                            activeKey: data.progress
                                        })
                                    }
                                })
                            },2000)
                        })
                    },()=>{})
                }
            })
        }, () => {})
    }

    //去授权
    toAuthorize() {
        CorpApi.getGoEnterpriseWeixinAuthoriztion((data) => {
            window.location.href = data.authURI
        }, () => {})
    }

    //去注册
    toRegister() {
        window.open("https://work.weixin.qq.com/");
    }

    //取消
    cancel() {
        this.props.history.push(Path.getFissionCustomer());
    }

    //提交
    // submitData() {
    //     let status = 6
    //     let bodyData = {
    //         status
    //     }
    //     CorpApi.getModificationAuthorizationState(bodyData, (data) => {
    //         this.setState({
    //             activeKey: status
    //         })
    //     }, (data) => {
    //         if (data.respCode == -1) {
    //             Message.error(data.respMsg ? data.respMsg : '提交失败，请联系客服')
    //         } else {
    //             Message.error('提交失败！')
    //         }
    //     })
    // }

    //下一步
    // nextWithCheck(key) {
    //     try {
    //         let activeKey = Number(this.state.activeKey)
    //         if (key > activeKey) {
    //             if (key == 2) {
    //                 this.alterState(key)
    //             }
    //             if (key == 3) {
    //                 this.authorizationSubmit.checkData()  //非空验证
    //                 CorpApi.getSubmitSeltBulidUseMessage(this.authorizationSubmit.getData(), (data) => {
    //                     Message.success('提交Secret和AgentId信息成功')
    //                     this.alterState(key)
    //                 }, (data) => {
    //                     if (data.respCode == 1010) {
    //                         Message.error('提交Secret和AgentId信息失败!')
    //                         // console.log(1)
    //                     }
    //                 })
    //             }
    //             if (key == 4) {
    //                 this.alterState(key)
    //             }
    //             if (key == 5) {
    //                 this.authorizationModification.checkData() //非空验证
    //                 CorpApi.getSubmitClientRelationPassword(this.authorizationModification.getData(), (data) => {
    //                     Message.success('修改应用权限成功')
    //                     this.alterState(key)
    //                 }, (data) => {
    //                     if (data.respCode == 1010) {
    //                         Message.error('修改应用权限失败')
    //                     }
    //                 })
    //             }
    //         } else {
    //             this.alterState(key)
    //         }
    //
    //     } catch (e) {
    //     }
    // }

    // alterState = (key) => {
    //     this.setState({
    //         activeKey: key
    //     }, () => {
    //         let bodyData = {
    //             status: this.state.activeKey
    //         }
    //         CorpApi.getModificationAuthorizationState(bodyData, (data) => {
    //             // console.log(data, '下一步')
    //         }, () => {
    //         })
    //     })
    // }

    // setActiveTab(key) {
    //     this.setState({
    //         activeKey: key + ""
    //     });
    //     Util.toTopScroll();
    // }

    //立即体验
    experienceImmediately() {
        location.reload()
    }

    //联系客服弹框
    contactCustomerService() {
        this.contactCustomerServicePop_up.show()
    }

    render() {
        return (
            <div className={'Access_enterprise_wechat'}>
                {
                    this.state.activeKey == 0 ?
                        <div className={'Access_enterprise_wechat_pop_up'}>
                            <div className={'Access_enterprise_wechat_title'}>接入企业微信</div>
                            <div className={'Access_enterprise_icon'}>
                                <span><IconEnterpriseWeChat/></span>
                                <label>X</label>
                                <span><img src={newAuthorization} style={{width:'75px',height:'28px'}}/></span>
                            </div>
                            <div className={'Access_enterprise_Button'}>
                                <div>
                                    <Button onClick={this.toAuthorize}><IconAuthorization/>去企业微信授权</Button>
                                </div>
                                <div>或</div>
                                <div>
                                    <Button onClick={this.toRegister}><IconAuthorizationBackups/>注册企业微信</Button>
                                </div>
                            </div>
                            <div className={'Access_enterprise_marked_words'}>
                                <div>
                                    <p><span></span>已注册企业微信的用户点击上方去企业微信授权</p>
                                    <p><span></span>未注册企业微信的用户请先注册企业微信</p>
                                </div>
                            </div>
                        </div>
                        : this.state.activeKey == 1 ? <div className={'qr_code_developed centered'}>
                            <div className={'administrator_access'}>
                                <div>
                                    <div className={'Access_enterprise_wechat_title'}>接入企业微信</div>
                                    <div className={'Access_enterprise_icon'}>
                                        <span><IconEnterpriseWeChat/></span>
                                        <label>X</label>
                                        <span><img src={newAuthorization} style={{width:'75px',height:'28px'}}/></span>
                                    </div>
                                </div>
                                <ul>
                                    <li>请用管理员企业微信扫码授权</li>
                                    <li>
                                        {
                                            this.state.qrCode !=undefined ? <img src={this.state.qrCode}/> : ''
                                        }
                                    </li>
                                    <li>不知道如何接入，可 <a onClick={this.contactCustomerService}>联系客服</a> 辅助接入</li>
                                </ul>
                            </div>

                        </div> :
                        this.state.activeKey == 2 ? <div className={'qr_code_developed contact_customer_service_to_open_trial'}>
                                <div>
                                    <div>
                                        <img src={authorizationSuccess}/>
                                        <span>恭喜您的管理员授权成功啦</span>
                                    </div>
                                    <ul>
                                        <li>联系客服开通试用</li>
                                        <li>
                                            <img src={customerServiceQRCode}/>
                                        </li>
                                        <li>扫码添加客服</li>
                                    </ul>
                                </div>
                            </div> :
                            this.state.activeKey == 6 ?
                                <div className={'Configuration_is_successful'}>
                                    <div className={'Configuration_is_successful_box'}>
                                        <div><IconSuccess/></div>
                                        <div>企业微信授权，配置成功</div>
                                        <div>
                                            <Button onClick={this.experienceImmediately}>立即体验</Button>
                                            <Link to={Path.getConfigCorpManage()}>
                                                <Button>修改配置</Button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                : ''
                    // <div className={'Enterprise_WeChat'}>
                    //     <header>
                    //         因API限制，目前配置流程比较复杂，若您在配置中有任何问题，可联系客服帮您进行配置！
                    //         <Button onClick={this.contactCustomerService}>联系客服</Button>
                    //     </header>
                    //     <div className={'Enterprise_WeChat_Article_steps'}>
                    //         <Steps current={this.state.activeKey - 1} size="small" labelPlacement="vertical">
                    //             <Step title="创建自建应用"/>
                    //             <Step title="提交Secret和AgentId信息"/>
                    //             <Step title="配置客户联系"/>
                    //             <Step title="修改应用权限"/>
                    //             <Step title="填写回调地址"/>
                    //         </Steps>
                    //     </div>
                    //     <div>
                    //         <Tabs activeKey={String(this.state.activeKey)}
                    //               onTabClick={this.setActiveTab.bind(this)}
                    //               animated=""
                    //         >
                    //             <TabPane key={'1'} forceRender={true}>
                    //                 <AuthorizationEstablish/>
                    //             </TabPane>
                    //             <TabPane key={'2'} forceRender={true}>
                    //                 <AuthorizationSubmit ref={r => this.authorizationSubmit = r}
                    //                                      data={this.state.postData}/>
                    //             </TabPane>
                    //             <TabPane key={'3'} forceRender={true}>
                    //                 <AuthorizationConfiguration/>
                    //             </TabPane>
                    //             <TabPane key={'4'} forceRender={true}>
                    //                 <AuthorizationModification ref={r => this.authorizationModification = r}
                    //                                            data={this.state.postData}/>
                    //             </TabPane>
                    //             <TabPane key={'5'} forceRender={false}>
                    //                 {/*{this.state.activeKey >2 ? <AuthorizationCallback/> : ''}*/}
                    //                 <AuthorizationCallback/>
                    //             </TabPane>
                    //         </Tabs>
                    //         <ZkModal title={'添加客服帮您进行配置'} ref={r => this.contactCustomerServicePop_up = r}
                    //                  width={'600px'} footer={false}>
                    //             <div className={'contactCustomerServicePop_up_box'}>
                    //                 <div>因API限制，需在进行配置后才能正常使用功能，请添加客服，我们会帮您进行配置</div>
                    //                 <div><img src={serviceOrCode}/></div>
                    //                 <div><IconWX/><label>添加专属客户，轻松完成企业微信配置</label></div>
                    //             </div>
                    //         </ZkModal>
                    //         <PopupMask>
                    //             <div className={"bottom-pannel"}>
                    //                 <div className='bottom-btns'>
                    //                     <NextStep max={5} okText="保存" onCancel={this.cancel.bind(this)}
                    //                               noCancel
                    //                               onOk={this.submitData.bind(this)}
                    //                               onChange={this.nextWithCheck.bind(this)}
                    //                               activeIndex={this.state.activeKey}
                    //                               loading={this.state.saveLoading}/>
                    //                 </div>
                    //             </div>
                    //         </PopupMask>
                    //     </div>
                    // </div>:''
                }
                <ZkModal title={'添加客服帮您进行配置'} ref={r => this.contactCustomerServicePop_up = r}
                         width={'500px'} footer={false}>
                    <div className={'contactCustomerServicePop_up_box'}>
                        <div><img src={customerServiceQRCode}/></div>
                        <div><IconWX/><label>添加专属客户，轻松完成企业微信配置</label></div>
                    </div>
                </ZkModal>
            </div>
        );
    }
}

export default StepByStep